import { render, staticRenderFns } from "./ObserverStats.vue?vue&type=template&id=027f9d14&"
import script from "./ObserverStats.vue?vue&type=script&lang=js&"
export * from "./ObserverStats.vue?vue&type=script&lang=js&"
import style0 from "./ObserverStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports